import { writable } from 'svelte/store';
import { SubmissionService } from '../../services/submission.service';
export const loading = writable(false);
export const submission = writable(null);
export const records = writable([]);
export async function initSubtasksList(sectionId, challengeId, submissionId) {
    //filter.set({ criteria: <ISubmission>{ oid: submissionId }, params: null, sorting: "" });
    //pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    fetchSubmission(submissionId);
    loadSubmissionSubtasks(submissionId);
}
export async function fetchSubmission(submissionId) {
    let _resp = await SubmissionService.fetchSubmission(submissionId);
    submission.set(_resp.payload);
}
export async function loadSubmissionSubtasks(submissionId) {
    loading.set(true);
    try {
        //let _filter = <ISearchFilterDTO<ISubmission>>({ criteria: <ISubmission>{ oid: submissionId }, params: null, sorting: "" });
        //let _pag = get(pagination);
        // let _pag: IApiPagination = { currentPage: 1, totalPages: 0, totalRecords: 0 };
        let _resp = await SubmissionService.getSubmissionSubtasks(submissionId);
        records.set(_resp.payload);
        //pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
